import * as React from 'react';
import {
  Col,
  Row,
  Link,
} from 'framework7-react';
import './languageSelector.css'
import i18next from "i18next";

export default class LanguageSelector extends React.Component {
    render() {
      const selected = localStorage.getItem("i18nextLng") || "en";

      return <div className={'language-selector-row'}>
        <Row noGap>
          <Col width="40">
            <Link className={selected==='no'&&'language-selected'} onClick={()=>i18next.changeLanguage('no')}>
            Norsk
            </Link>
          </Col>
          <Col width="5">
              <span style={{opacity:0.4}}>|</span>
          </Col>
          <Col width="50">
            <Link className={selected==='en'&&'language-selected'} onClick={()=>i18next.changeLanguage('en')}>
            English
            </Link>
          </Col>
        </Row>
      </div>
    }
};